import { useNavigate } from 'react-router-dom';
import { useCompany } from '@/contexts/useCompany';
import { useFeature } from '@/hooks/useFeature';

/**
 * Ação "criar empresa" — o PORTÃO DE PLANO mora aqui, e em nenhum outro lugar.
 *
 * Ela nasceu privada dentro do `CompanyList` (`handleAddClick`). Quando o
 * desenho oficial chegou às Configurações, a ação primária subiu para o HERO
 * (#186/#188) e passou a ter DOIS call-sites — o botão do hero e o estado vazio
 * da lista, mais o atalho `?action=new`. Copiar as três linhas do gate seria uma
 * segunda implementação da mesma regra de negócio, pronta para divergir na
 * primeira correção sem erro nenhum na tela (o modo de falha do #82/#69).
 *
 * O gate: o plano gratuito tem UMA empresa. `require()` abre a paywall e devolve
 * `false` — por isso a navegação só acontece depois dele, nunca em paralelo.
 */
export function useNewCompanyAction() {
  const { companies } = useCompany();
  const multipleCompanies = useFeature('multiple_companies');
  const navigate = useNavigate();

  const startNewCompany = () => {
    if (companies.length >= 1 && !multipleCompanies.require()) return;
    navigate('/companies/new');
  };

  return { startNewCompany, multipleCompanies };
}
